var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEscudoMb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1098",
    "data-name": "Grupo 1098",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 189.001,
    viewBox: "0 0 163 189.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M368.785,286.131c-13.957,0-25.26-11.735-25.26-25.689V259.16H234.469v1.282c0,13.955-11.3,25.689-25.26,25.689H207.5v38.758a129.282,129.282,0,0,0,57.809,107.62L289,448.161l23.693-15.652A129.288,129.288,0,0,0,370.5,324.889V286.131Z",
    transform: "translate(-207.497 -259.16)",
    fill: "#ffc200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(40.076 14.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M232.653,270.142h5.463l-4.42,2.927,1.688,5.108-4.419-3.323-4.419,3.134,1.688-4.886-4.42-2.96h5.462l1.688-5.2Z",
    transform: "translate(-223.815 -264.946)",
    fill: "#0e1221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M239.555,270.142h5.463l-4.42,2.927,1.688,5.108-4.419-3.323-4.419,3.134,1.688-4.886-4.42-2.96h5.462l1.688-5.2Z",
    transform: "translate(-213.766 -264.946)",
    fill: "#0e1221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M246.456,270.142h5.463l-4.42,2.927,1.688,5.108-4.419-3.323-4.418,3.134,1.688-4.886-4.42-2.96h5.462l1.688-5.2Z",
    transform: "translate(-203.717 -264.946)",
    fill: "#0e1221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M253.358,270.142h5.463l-4.42,2.927,1.688,5.108-4.42-3.323-4.419,3.134,1.688-4.886-4.42-2.96h5.462l1.688-5.2Z",
    transform: "translate(-193.668 -264.946)",
    fill: "#0e1221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M260.26,270.142h5.463l-4.42,2.927,1.688,5.108-4.419-3.323-4.419,3.134,1.688-4.886-4.42-2.96h5.462l1.688-5.2Z",
    transform: "translate(-183.62 -264.946)",
    fill: "#0e1221"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(27.023 35.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M243.337,285.376l-8.095-11.5H218.655v74.841c-1.238,12.427,5.352,16.679,5.352,16.679l11.148,7.2V298.84l8.294,12.1,8.028-11.774v95.446l16.764,10.794V273.875H251.786Z",
    transform: "translate(-218.5 -273.622)",
    fill: "#0e1221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M286.515,320.322l5.045-6.214V273.772h-49.1V405.809L282,373.973c9.821-8.073,9.821-23.4,9.821-23.4v-23.71Zm-11.676,29.435-16.057,10.63V331.278h16.057Zm0-38.591H258.782V294.485h16.057Z",
    transform: "translate(-183.615 -273.772)",
    fill: "#0e1221"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEscudoMb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/escudo-mb.efbd3b2932e5b0b4e001fb989d70df88.svg";